import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificateNoteService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote?token=" + Token).pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }

  GetActiveList(Token: String): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }



  AddCertificateNote(model: CertificateNote_Interface, Token: String): Observable<CertificateNote_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      dsc: model.dsc,
      code: model.code,
      del: false,
      username: Token,
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/CertificateNote/Add", body, { headers }).pipe(
      map(data => {
        return data as CertificateNote_Interface
      })
    )

  }


  DeleteCertificateNote(id: number, Token: String): Observable<CertificateNote_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as CertificateNote_Interface
      })
    )

  }


  GetActiveListCertificate(Token: String,id:number): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/GetActiveListCertificate?token=" + Token+"&id="+id).pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }


  SubmitCertificate(calibration_id:number,id:number,Token:String):Observable<CertificateNote_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/SubmitCertificate?token="+Token
      +"&calibration_detail_id="+calibration_id
      +"&certificate_id="+id
    ).pipe(
      map(data=>{
        return data as CertificateNote_Interface
      })
    )
  }

  DeleteCertificate(calibration_id:number,id:number,Token:String):Observable<CertificateNote_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/DeleteCertificate?token="+Token
      +"&calibration_detail_id="+calibration_id
      +"&certificate_id="+id
    ).pipe(
      map(data=>{
        return data as CertificateNote_Interface
      })
    )
  }

}
